import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".element-stackablecontents").forEach((el) => {
  const items = el.querySelectorAll(".stackable-item");

  if (!items.length) return;

  items.forEach((item, index) => {
    gsap.set(item, {
      zIndex: items.length + index,
    });
  });

  items.forEach((item, index) => {
    if (index === items.length - 1) return;

    ScrollTrigger.create({
      trigger: item,
      start: "top top",
      end: () => {
        const nextItem = items[index + 1];
        if (nextItem) {
          return `+=${nextItem.offsetHeight * 0.6}`;
        }
        return "+=100vh";
      },
      pin: true,
      pinSpacing: false,
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        if (progress > 0.5) {
          const fadeProgress = (progress - 0.5) / 0.5;
          const opacity = 1 - fadeProgress;
          gsap.set(item, { opacity: Math.max(opacity, 0) });
        } else {
          gsap.set(item, { opacity: 1 });
        }
      },
    });
  });

  items.forEach((item, index) => {
    gsap.set(item, { y: 300 });

    ScrollTrigger.create({
      trigger: item,
      start: "top bottom",
      end: "top top",
      scrub: true,
      onUpdate: (self) => {
        const progress = self.progress;
        const translateY = 300 - 300 * progress;
        gsap.set(item, { y: translateY });
      },
    });
  });
});
